/**
 * Décide si un clic backdrop doit fermer le dialogue (BL-0514).
 * Exige que le pointeur ait démarré ET terminé sur l’overlay — évite la fermeture
 * quand une sélection texte commence dans le panneau et se termine sur le fond.
 */
export function u2000ShouldInvokeDialogBackdropClick(
  pointerDownOnBackdrop: boolean,
  clickTargetIsOverlay: boolean
): boolean {
  return pointerDownOnBackdrop && clickTargetIsOverlay;
}
